import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ExpenseReportAdminService {

  constructor(private _http: HttpClient, private _toastrService: ToastrService) { }

  getAllData(formdata: any): Observable<any> {
    return this._http
      .post(`${environment.apiUrl}expense-adminreport`,formdata)
      .pipe(
        map(data => {
          return data;
        })
      );
  }

  getmeta(user_id:any,start_date:any,end_date:any): Observable<any> {
    return this._http.post(`${environment.apiUrl}expense-reportmetaadmin`, {user_id,start_date,end_date});
  }

  getuserDropDown(): Observable<any> {
    return this._http
      .post(`${environment.apiUrl}user-dropdown`, { })
      .pipe(
        map(data => {
          return data;
        })
      );
  }
  fileDownload(formdata: any): Observable<any> {
    return this._http
      .post(`${environment.apiUrl}export-admin-report`,formdata)
      .pipe(
        map(data => {
          return data;
        })
      );
  }
}
